import ApiUtil from '../utils/ApiUtil';
import {getRequest} from './api';

export const getNewsApi = (args, callback, dispatch) => {
  const endpoint = '/v2/news/get',
    token = args.token,
    qs = `search=${args.search}&category=${args.category}&companyId=${args.companyId}&highlighted=${args.highlighted}&limit=${args.limit}&key=${args.key}`,
    headers = {'Cache-Control': 'no-cache, no-store, must-revalidate'};

  getRequest({endpoint, token, qs}, headers, (err, res) => {
    ApiUtil.handleReponse(err, res, callback, dispatch);
  });
};